<template>
  <section
    class="hero is-fullheight is-dark"
    :class="{ 'color-shift': step === 0 || step === 1 || step === 2 || step === 3 }"
  >
    <div
      v-touch:swipe="swipeHandler"
      class="hero-body"
    >
      <div class="custom-container">
        <splash
          v-if="step === 0"
          @next-step="nextStep"
        />
        <who
          v-else-if="step === 1"
          :user-data="user"
          @next-step="nextStep"
          @go-to-splash="step = 0"
        />
        <questions
          v-else-if="step === 2"
          :swipe="swipeDir"
          @next-step="nextStep"
          @prev-step="prevStep"
          @go-to-splash="step = 0"
          @swiped="swipeDir = 'none'"
        />
        <result
          v-else-if="step === 3"
          :quiz-data="{ user: user, answers: answers }"
          @go-to-splash="step = 0"
        />
      </div>
    </div>
    <!-- <footer v-if="step ===3" class="footer footer-bg">
      <p class="is-style-accent is-size-4-desktop is-size-5-mobile is-italic is-footer">        
        DISCLAIMER: This quiz is designed to help you know the divisions that might be of your interest, but, don't forget to choose the division you truly know you want to be a part of.
      </p>
      <p class="is-style-accent is-size-3-desktop is-size-5-mobile is-footer-2">
        Ready to join the blue family? Click <a href="https://www.icmssfebui.com/associate-registration"><b>here</b> </a> to register now.
      </p>
    </footer> -->
  </section>
</template>

<script>
import Splash from "../components/Splash.vue";
import Who from "../components/Who.vue";
import Questions from "../components/Questions.vue";
import Result from "../components/Result.vue";

export default {
  name: "Quiz",
  components: {
    Splash,
    Who,
    Questions,
    Result,
  },
  data() {
    return {
      step: 0,
      user: {},
      answers: {},
      swipeDir: "none",
    };
  },
  methods: {
    nextStep(data) {
      if (this.step === 1) this.user = data;
      if (this.step === 2) {
        const dataObj = data.answers.reduce((accum, value, idx) => {
          return { ...accum, [idx.toString()]: value };
        }, {});
        this.answers = dataObj;
      }
      this.step++;
    },
    prevStep() {
      if (this.step > 0) {
        this.step--;
      }
    },
    swipeHandler(direction) {
      this.swipeDir = direction;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Roboto&display=swap");
@import url("https://fonts.googleapis.com/css?family=Montserrat&display=swap");

.custom-container {
  width: 100%;
  padding: 0 20px;
}

* {
  font-family: "Roboto", sans-serif;
}
.is-style-accent {
  font-family: "Monsterrat", sans-serif;
}
html {
  scroll-behavior: smooth;
}
.is-centered {
  justify-content: center;
}
.title {
  font-style: italic;
}

.is-italic {
  font-style: italic;
}

.is-footer {
  color: white !important;
  text-align: center !important;
}
.is-footer-2 {
  color: white !important;
  text-align: center !important;
  margin-top: 20px;
  padding-bottom: -2rem;
  margin-bottom: -2rem;
}
.footer {
  padding-bottom: -10px !important;
}
.footer-bg {
  background-color: rgba(0, 9, 66, 0.5) !important;
  opacity: 0.7;
}

.color-shift {
  animation: bg-color 5s linear infinite;
}
@keyframes bg-color {
  0% {
    background-color: #002147;
  }
  25% {
    background-color: #022754;
  }
  50% {
    background-color: #05417C;
  }
  75% {
    background-color: #022754;
  }
  100% {
    background-color: #002147;
  }
}

@media screen and (min-width: 991px) {
  .title {
    font-size: 72px !important;
  }
  .subtitle {
    font-size: 36px !important;
  }
}

@media screen and (min-width: 1025px) {
  .title {
    font-size: 72px !important;
  }
  .subtitle {
    font-size: 42px !important;
  }
}
</style>